// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newsletter-page {
  max-width: 46rem;
  margin: 0 auto;
  padding: 2.25rem 1.5rem 4rem;
}

.newsletter-container {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0.75rem;
}

.newsletter-title {
  margin: 0;
}

.newsletter-description {
  margin: 0;
  font-size: 1.08rem;
}

.newsletter-frequency-hint {
  margin: 0;
  font-family: var(--font-mono);
  font-size: 0.74rem;
  letter-spacing: 0.04em;
  color: var(--text-tertiary);
}

.newsletter-form {
  display: grid;
  gap: 0.9rem;
  margin-top: 1rem;
  padding: clamp(1rem, 3vw, 1.5rem);
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
}

.newsletter-input {
  width: 100%;
  background: var(--bg-primary);
}

.newsletter-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
}

.newsletter-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 0.6rem 1.1rem;
  border: 1px solid var(--accent-primary);
  border-radius: var(--radius-sm);
  font-family: var(--font-mono);
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.btn-subscribe {
  background: var(--accent-primary);
  color: var(--on-accent);
}

.btn-subscribe:hover:not(:disabled) {
  background: var(--accent-hover);
}

.btn-unsubscribe {
  background: transparent;
  color: var(--accent-primary);
}

.btn-unsubscribe:hover:not(:disabled) {
  background: var(--accent-soft);
}

.newsletter-message {
  padding: 0.6rem 0.8rem;
  border: 1px solid currentColor;
  font-size: 0.92rem;
}

.newsletter-message.success {
  color: var(--success);
}

.newsletter-message.error {
  color: var(--error);
}

@media (max-width: 680px) {
  .newsletter-page {
    padding: 1.5rem 1rem 3rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/NewsletterPage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,uCAAuC;EACvC,+BAA+B;EAC/B,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".newsletter-page {\n  max-width: 46rem;\n  margin: 0 auto;\n  padding: 2.25rem 1.5rem 4rem;\n}\n\n.newsletter-container {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 0.75rem;\n}\n\n.newsletter-title {\n  margin: 0;\n}\n\n.newsletter-description {\n  margin: 0;\n  font-size: 1.08rem;\n}\n\n.newsletter-frequency-hint {\n  margin: 0;\n  font-family: var(--font-mono);\n  font-size: 0.74rem;\n  letter-spacing: 0.04em;\n  color: var(--text-tertiary);\n}\n\n.newsletter-form {\n  display: grid;\n  gap: 0.9rem;\n  margin-top: 1rem;\n  padding: clamp(1rem, 3vw, 1.5rem);\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n}\n\n.newsletter-input {\n  width: 100%;\n  background: var(--bg-primary);\n}\n\n.newsletter-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.6rem;\n}\n\n.newsletter-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 44px;\n  padding: 0.6rem 1.1rem;\n  border: 1px solid var(--accent-primary);\n  border-radius: var(--radius-sm);\n  font-family: var(--font-mono);\n  font-size: 0.78rem;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.btn-subscribe {\n  background: var(--accent-primary);\n  color: var(--on-accent);\n}\n\n.btn-subscribe:hover:not(:disabled) {\n  background: var(--accent-hover);\n}\n\n.btn-unsubscribe {\n  background: transparent;\n  color: var(--accent-primary);\n}\n\n.btn-unsubscribe:hover:not(:disabled) {\n  background: var(--accent-soft);\n}\n\n.newsletter-message {\n  padding: 0.6rem 0.8rem;\n  border: 1px solid currentColor;\n  font-size: 0.92rem;\n}\n\n.newsletter-message.success {\n  color: var(--success);\n}\n\n.newsletter-message.error {\n  color: var(--error);\n}\n\n@media (max-width: 680px) {\n  .newsletter-page {\n    padding: 1.5rem 1rem 3rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
